import { Region } from './region.model';

export interface PARTy {
    ID: number;
    PARTY_ROLES: PARTYROLE[];
}
export interface PARTYROLE {
    ID: number;
    PARTIES_ID: number;
}

export interface ORGANIZATION {
    ID: number;
    PARTIES_ID: number;
    NAME: string;
    PARTy: PARTy;
}

export class County {
    ID!: number;
    COUNTY_NAME: string | undefined;
    COUNTY_CODE!: string;
    ORGANIZATIONS_ID!: number;
    ORGANIZATION: ORGANIZATION | undefined;
    REGION: Region;
    REGIONS: Region[];
}

export function compareCounty(c1: County, c2: County) {
    const compare = parseInt(c2.COUNTY_CODE) - parseInt(c1.COUNTY_CODE);

    if (compare < 0) {
        return 1;
    } else if (compare > 0) {
        return -1;
    } else return 0;
}
